import { useState } from "react";
import { type Sesion, iniciarSesion, apiConfigurada } from "../api.ts";
import { C, SERIF, st } from "../theme.ts";
import { ErrorBox } from "../ui/componentes.tsx";

/**
 * Login mínimo — password grant contra GoTrue. Nexo es dato de referencia
 * global de solo lectura: basta cualquier cuenta del proyecto (aal1); sin
 * resolución de tenant ni rol, sin flujo MFA (recomendado, no obligatorio).
 */
export function Login({ onSesion }: { onSesion: (s: Sesion) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function entrar(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setEnviando(true);
    try {
      onSesion(await iniciarSesion(email.trim(), password));
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ width: 360, maxWidth: "100%" }}>
        <div style={{ textAlign: "center", marginBottom: 18 }}>
          <div style={{ fontFamily: SERIF, fontSize: 34, letterSpacing: "0.14em", color: C.tielDark }}>
            ARGUS
          </div>
          <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.28em", color: C.oro, textTransform: "uppercase" }}>
            Nexo
          </div>
          <p style={{ fontSize: 13, color: C.muted, margin: "10px 0 0" }}>
            Grafo de sanciones: lista de OFAC y lista del SAT de empresas que emiten facturas falsas
          </p>
        </div>

        <form onSubmit={(e) => { void entrar(e); }} style={{ ...st.tarjeta, padding: "20px 22px" }}>
          <label style={st.label} htmlFor="email">Correo</label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            style={{ ...st.input, width: "100%", marginBottom: 12 }}
            value={email}
            onChange={(e) => { setEmail(e.target.value); }}
            required
          />
          <label style={st.label} htmlFor="password">Contraseña</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            style={{ ...st.input, width: "100%", marginBottom: 14 }}
            value={password}
            onChange={(e) => { setPassword(e.target.value); }}
            required
          />
          {error ? <ErrorBox mensaje={error} /> : null}
          {!apiConfigurada() ? <ErrorBox mensaje="Backend no configurado (VITE_SUPABASE_URL)." /> : null}
          <button type="submit" style={{ ...st.btnPrim, width: "100%" }} disabled={enviando}>
            {enviando ? "Entrando…" : "Entrar"}
          </button>
        </form>

        <p style={{ fontSize: 11.5, color: C.muted, textAlign: "center", marginTop: 12 }}>
          Acceso con cuenta Argus. Datos de fuentes públicas (OFAC, SAT); uso interno y de demostración.
        </p>
      </div>
    </div>
  );
}
